import React, { createContext, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { APIRequest } from "../model/APIRequest";
import { APIResponse } from "../model/APIResponse";
import { DTORequest } from "../model/DTORequest";
import { APIService } from "../services/APIService";
import { ProgressSpinner } from "primereact/progressspinner";
import SplashScreen from "../component/SplashScreen";

// Define types for AuthGuard context value
interface AuthGuardContextType {
    authGuardData: APIResponse | null;
}


const AuthGuardContext = createContext<AuthGuardContextType | null>(null);

interface AuthGuardProps {
    children: React.ReactNode,
}

export const AuthGuardProvider: React.FC<AuthGuardProps> = ({ children }) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<APIResponse>({ errorCode: 0, msg: "" });

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const checkAuth = async () => {
            try {
                // setLoading(true);
                const apiClient = new APIService(process.env.REACT_APP_API_URL || "http://localhost:4000");
                let dtoRequest: DTORequest = {
                    clientMac: localStorage.getItem("clientMac") || "",
                    ssidName: localStorage.getItem("ssidName") || "",
                    radioId: Number(localStorage.getItem("radioId")),
                    apMac: localStorage.getItem("apMac") || "",
                    site: localStorage.getItem("site") || "",
                };

                if (!dtoRequest.clientMac) {
                    navigate("/nomacaddress", { replace: true });
                    return;
                }

                const clientInfo = await apiClient.clientRecord(dtoRequest)
                console.log("Client Info:", clientInfo);
                setData(clientInfo);

                if (clientInfo.errorCode === 0 && clientInfo.result?.data?.length > 0) {
                    if (location.pathname !== '/dashboard') {
                        setLoading(false);
                        navigate('/dashboard', { replace: true });
                    }
                } else {
                    if (location.pathname !== '/') {
                        setLoading(false);
                        navigate('/', { replace: true });
                    }
                }

            } catch (error) {
                console.error("Authentication check failed:", error);
                // Fallback to main route on error
                // if (targetRoute !== "/") {
                //     navigate("/", { replace: true });
                // }

                navigate("/", { replace: true });
            } finally {
                setLoading(false); // Stop loading once the check is complete
            }
        };

        checkAuth();
    }, [navigate]);

    // Show a loading spinner or null while checking authentication
    if (loading) return <SplashScreen message="Loading...." />;

    return (
        <AuthGuardContext.Provider value={{ authGuardData: data }}>
            {children}
        </AuthGuardContext.Provider>
    );
};

// Custom hook to access AuthGuardContext
export const useAuthGuard = (): AuthGuardContextType | null => {
    return useContext(AuthGuardContext);
};
